import { CZ_MenuCollection } from '@/types/cmsGenerated'
import { ComponentContext } from '@/types/cmsConfig'
import { renderLayout } from '@/cms_components'
import { PropsWithChildren } from 'react'
import clsx from 'clsx'

interface Props {
    navbarData: CZ_MenuCollection
    context: ComponentContext
}
export function Navbar({ navbarData, context }: Props) {
    return (
        <NavbarWrapper>
            <div className="flex items-center w-full">
                {renderLayout(navbarData.menuItems, context)}
            </div>
        </NavbarWrapper>
    )
}

export function NavbarWrapper({
    className,
    children,
}: PropsWithChildren<{ className?: string }>) {
    return (
        <header
            className={clsx(
                'fixed top-0 backdrop-blur z-50 bg-base-100/80 flex flex-row w-full p-2 items-center',
                className
            )}
        >
            {children}
        </header>
    )
}
